import { SET_TAB_LIST } from '../actions/types';

// TODO: change to use ES6 arrow functions
export default function tabList(state = {}, action = null) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_TAB_LIST:
				return action.payload;
			// no default
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/tabList.js